import { render, staticRenderFns } from "./ProfileDropDown.vue?vue&type=template&id=2285e740&"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js&"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDropDown.vue?vue&type=style&index=0&id=2285e740&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports